// « Composez votre carton » : cocher, recalculer le prix affiché, pointer le champ id.
// Rien d'autre. Les libellés, les écarts et le récapitulatif sont déjà dans le HTML servi ;
// ce script ne fait que les tenir à jour quand on clique.
(function () {
  'use strict';

  var racine = document.querySelector('[data-compo]');
  var donneesBrutes = document.querySelector('[data-compo-donnees]');
  var formulaire = document.getElementById('formulaire-produit');
  if (!racine || !donneesBrutes || !formulaire) { return; }

  var D;
  try { D = JSON.parse(donneesBrutes.textContent); } catch (e) { return; }
  if (!D || !D.combinaisons || !D.combinaisons.length) { return; }

  var champId = formulaire.querySelector('input[name="id"]');
  if (!champId) { return; }

  // Le script a pris la main : le sélecteur natif n'a plus lieu d'être. Sans lui, il reste.
  var natif = document.querySelector('[data-variantes]');
  if (natif) { natif.hidden = true; }

  var etat = Object.assign({}, D.defaut);

  function memeEtat(a, b) {
    for (var k in b) { if (String(a[k]) !== String(b[k])) { return false; } }
    return true;
  }

  function combinaisonPour(e) {
    for (var i = 0; i < D.combinaisons.length; i++) {
      if (memeEtat(D.combinaisons[i].etat, e)) { return D.combinaisons[i]; }
    }
    return null;
  }

  // L'état qu'on obtiendrait en prenant cette option, sans rien changer d'autre.
  function etatAvec(opt, depuis) {
    var e = Object.assign({}, depuis);
    var cle = opt.getAttribute('data-compo-cle');
    var groupe = opt.closest('[data-compo-groupe]');
    if (groupe.getAttribute('data-compo-type') === 'radio') {
      e[cle] = opt.getAttribute('data-compo-option');
    } else {
      e[cle] = true;
    }
    return e;
  }

  // Le prix est mis en forme par le thème, pas par le script : on reprend la mise en forme
  // du prix déjà affiché plutôt que d'inventer un format qui varierait selon le marché.
  // Le nombre est la seule partie qui change ; tout ce qui l'entoure est conservé tel quel,
  // espace fine insécable comprise.
  var modele = (function () {
    var exemple = document.querySelector('[data-prix-affiche]');
    var texte = exemple ? exemple.textContent.trim() : '';
    var nombre = texte.match(/[0-9][0-9  .,\s]*[0-9]|[0-9]/);
    if (!nombre) { return { avant: '', apres: ' €', virgule: true }; }
    return {
      avant: texte.slice(0, nombre.index),
      apres: texte.slice(nombre.index + nombre[0].length),
      virgule: nombre[0].indexOf(',') > -1,
    };
  })();

  function enPrix(centimes) {
    var n = (centimes / 100).toFixed(2);
    if (modele.virgule) { n = n.replace('.', ','); }
    return modele.avant + n + modele.apres;
  }

  function majEcarts() {
    var courante = combinaisonPour(etat);
    var prixCourant = courante ? courante.prix : D.base;

    racine.querySelectorAll('[data-compo-option]').forEach(function (opt) {
      var cible = opt.querySelector('.compo__ecart');
      if (!cible) { return; }
      var groupe = opt.closest('[data-compo-groupe]');
      var radio = groupe.getAttribute('data-compo-type') === 'radio';
      var cle = opt.getAttribute('data-compo-cle');
      var prise = opt.getAttribute('aria-checked') === 'true';

      // Ce que coûte l'option en plus de l'état sans elle : une option déjà cochée n'a pas
      // d'écart à afficher par rapport à elle-même.
      var depuis = etat;
      if (prise && !radio) {
        depuis = Object.assign({}, etat);
        depuis[cle] = false;
      }
      var sans = combinaisonPour(depuis);
      var avec = combinaisonPour(etatAvec(opt, depuis));
      if (!avec || !sans) { return; }

      var ecart = avec.prix - (radio ? prixCourant : sans.prix);
      cible.classList.toggle('compo__ecart--nul', ecart === 0);
      // Une option qui ne change rien au prix ne montre pas « + 0,00 € » : elle est incluse.
      cible.textContent = ecart === 0 ? D.inclus : (ecart > 0 ? '+ ' : '− ') + enPrix(Math.abs(ecart));
    });
  }

  function appliquer() {
    var c = combinaisonPour(etat);
    if (!c) { return; }

    champId.value = c.variante;

    // La galerie suit la composition : la photo montre le carton qu'on est en train de
    // composer, pas celui de la variante par défaut.
    if (c.image) {
      // LA GALERIE EST UNE PISTE : on l'AMÈNE sur la vue de cette composition, on ne remplace
      // plus la source de la première image. Remplacer une source dans une piste ferait mentir
      // la vue n° 1 sur ce qu'elle montre, et les vignettes ne correspondraient plus à rien.
      var piste = document.querySelector('[data-galerie-piste]');
      var vues = piste ? Array.prototype.slice.call(piste.querySelectorAll('[data-galerie-vue]')) : [];
      var vise = c.image.split('?')[0];
      var i = -1;
      vues.forEach(function (v, j) {
        if ((v.getAttribute('data-src') || '').split('?')[0] === vise) { i = j; }
      });
      if (piste && i >= 0) { piste.scrollLeft = i * piste.clientWidth; }
      document.querySelectorAll('[data-galerie-vignette]').forEach(function (b, j) {
        var sienne = i >= 0
          ? j === i
          : (b.getAttribute('data-src') || '').split('?')[0] === vise;
        b.setAttribute('aria-current', sienne ? 'true' : 'false');
      });
    }

    document.querySelectorAll('[data-prix-affiche]').forEach(function (n) {
      var cible = n.querySelector('.prix-valeur') || n;
      cible.textContent = enPrix(c.prix);
    });

    
    var contenu = D.contenu_base.slice();
    racine.querySelectorAll('[data-compo-option]').forEach(function (opt) {
      if (opt.getAttribute('aria-checked') !== 'true') { return; }
      var brut = opt.getAttribute('data-compo-contenu');
      if (brut) { brut.split('§').filter(Boolean).forEach(function (x) { contenu.push(x); }); }
    });
    var liste = racine.querySelector('[data-compo-recap-liste]');
    if (liste) { liste.textContent = contenu.join(', ') + '.'; }

    racine.querySelectorAll('[data-compo-avertissement]').forEach(function (avert) {
      var pour = avert.getAttribute('data-compo-avertissement');
      var opt = racine.querySelector('[data-compo-option="' + pour + '"]');
      var visible = !!opt && opt.getAttribute('aria-checked') === 'true';
      avert.classList.toggle('compo__avertissement--muet', !visible);
      if (visible) { avert.removeAttribute('aria-hidden'); } else { avert.setAttribute('aria-hidden', 'true'); }
    });

    majEcarts();
  }

  function basculer(opt) {
    if (opt.getAttribute('aria-disabled') === 'true') { return; }
    var groupe = opt.closest('[data-compo-groupe]');
    var cle = opt.getAttribute('data-compo-cle');
    var radio = groupe.getAttribute('data-compo-type') === 'radio';
    var avant = etat[cle];

    if (radio) {
      groupe.querySelectorAll('[data-compo-option]').forEach(function (o) {
        o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
      });
      etat[cle] = opt.getAttribute('data-compo-option');
    } else {
      var actif = opt.getAttribute('aria-checked') === 'true';
      opt.setAttribute('aria-checked', actif ? 'false' : 'true');
      etat[cle] = !actif;
    }

    // Une combinaison qui n'existe pas ne se compose pas : on revient en arrière.
    if (!combinaisonPour(etat)) {
      etat[cle] = avant;
      if (radio) {
        groupe.querySelectorAll('[data-compo-option]').forEach(function (o) {
          o.setAttribute('aria-checked', o.getAttribute('data-compo-option') === String(avant) ? 'true' : 'false');
        });
      } else {
        opt.setAttribute('aria-checked', avant ? 'true' : 'false');
      }
      return;
    }
    appliquer();
  }

  racine.querySelectorAll('[data-compo-option]').forEach(function (opt) {
    opt.addEventListener('click', function () { basculer(opt); });
    opt.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
        e.preventDefault();
        basculer(opt);
      }
    });
  });

  appliquer();
})();
